// Import dependencies
import { initialiser } from '../../ramen-imports/utilitybelt';
import { addClasses, removeClasses } from '../../utils';

class VideoModal {
  constructor(config) {
    const { el, settings } = config;

    // Set module dom elements
    this.container = el;
    this.button = el.querySelector(settings.modalButton);
    this.modalId = this.button.getAttribute(settings.modalIdAttr);
    this.videoType = this.button.getAttribute(settings.videoTypeAttr);
    this.videoId = this.button.getAttribute(settings.videoIdAttr);
    this.videoPoster = this.button.getAttribute(settings.videoPosterAttr);
    this.modal = document.getElementById(this.modalId);
    this.closeButton = this.modal && this.modal.querySelector(settings.closeButton);
    this.modalInner = this.modal && this.modal.querySelector(settings.modalInner);
    this.videoFrame = this.modal.querySelector('iframe');
    this.nativeVideo = this.modal.querySelector('video');
    this.loader = this.modal.querySelector(settings.loader);
    this.youtubeVideoSrc = `https://www.youtube.com/embed/${this.videoId}?rel=0&amp;showinfo=0`;
    this.vimeoVideoSrc = `https://player.vimeo.com/video/${this.videoId}?title=0&amp;color=e10600`;

    // Set settings
    this.settings = settings;
  }

  // Initialisation Function
  init = () => {
    if (!this.container || !this.button || !this.modalId) return;

    this.button.addEventListener('click', this.toggleModal);
    this.modal.addEventListener('click', this.handleBodyClick);
    document.addEventListener('keyup', this.handleKeyUp);

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.closeModal);
    }
  };

  handleKeyUp = (e) => {
    if (e.key === 'Escape' || e.keyCode === 27) {
      this.closeModal(e);
    }
  };

  toggleModal = (e) => {
    e.preventDefault();
    this.modal.classList.toggle(this.settings.modalOpen);
    document.body.classList.toggle(this.settings.showOverlay);
    addClasses(this.loader, this.settings.modalOpen);

    this.setupNativeVideoPoster();
    if (this.videoId) this.showVideo();

    // Hide loader once iframe/video frame is loaded
    setTimeout(() => {
      removeClasses(this.loader, this.settings.modalOpen);
    }, 2000);
  };

  closeModal = (e) => {
    e.preventDefault();
    removeClasses(this.modal, this.settings.modalOpen);
    removeClasses(document.body, this.settings.showOverlay);
    removeClasses(this.loader, this.settings.modalOpen);

    if (this.videoId) this.hideVideo();
  };

  handleBodyClick = (e) => {
    // if the overlay is clicked, close the modal
    if (!this.modalInner.contains(e.target)) {
      this.closeModal(e);
    }
  };

  hideVideo = () => {
    const videoSource = this.videoFrame.getAttribute('src');
    const nativeVideoSource = this.nativeVideo.getAttribute('src');

    if (videoSource) {
      this.videoFrame.setAttribute('src', '');
      removeClasses(this.videoFrame, this.settings.modalOpen);
    } else if (nativeVideoSource) {
      this.nativeVideo.setAttribute('src', '');
      removeClasses(this.nativeVideo, this.settings.modalOpen);
    }
  };

  showVideo = () => {
    if (this.videoType === 'youtube') {
      addClasses(this.videoFrame, this.settings.modalOpen);
      this.videoFrame.setAttribute('src', this.youtubeVideoSrc);
    } else if (this.videoType === 'vimeo') {
      addClasses(this.videoFrame, this.settings.modalOpen);
      this.videoFrame.setAttribute('src', this.vimeoVideoSrc);
    } else if (this.videoType === 'nativeVideo') {
      addClasses(this.nativeVideo, this.settings.modalOpen);
      this.nativeVideo.setAttribute('src', this.videoId);
    }
  };

  /**
   * Iphone and a few safari versions don't render video thumbnails/image.
   * To fix this issue, adding "poster" attribute to native HTML5 video.
   */

  setupNativeVideoPoster = () => {
    if (this.videoType === 'nativeVideo' && this.videoPoster) {
      this.nativeVideo.setAttribute('poster', this.videoPoster);
    }
  };
}

export default (settings) => initialiser(settings, VideoModal);
